export default __webpack_public_path__ + "static/img-3a0005a7e64677fc0dfe7b62309ccefa.png";